import { render, staticRenderFns } from "./EdicaoIndividualDlg.vue?vue&type=template&id=071a8978"
import script from "./EdicaoIndividualDlg.vue?vue&type=script&lang=js"
export * from "./EdicaoIndividualDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports